<template>
  <div>
    <AppLoadingPage v-if="$apollo.queries.eventFinancialReport.loading" />
    <PersonStatementReportTemplate
      v-else
      :event-financial-report="eventFinancialReport"
      :event="event"
    />
  </div>
</template>
<script>
import gql from "fraql";
import AppLoadingPage from "@elements/AppLoadingPage.vue";
import PersonStatementReportTemplate from "./PersonStatementReportTemplate.vue";
export default {
  name: "PersonStatementReport",
  components: { AppLoadingPage, PersonStatementReportTemplate },
  props: {
    event: {
      type: Object,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  apollo: {
    eventFinancialReport: {
      query: gql`
        query person($id: ID, $eventId: ID) {
          person(id: $id) {
            id
            eventFinancialReport(eventId: $eventId) {

              confirmedPayments {
                id
                amountCents
                processor
                referenceCode
                confirmedAt
              }

              confirmedPayouts {
                id
                amountCents
                referenceCode
                processor
                recipientContact {
                  id
                  iban
                  name
                }
                confirmedAt
              }

              expenseItems {
                id
                aggregatedByEntityClass
                amountCents
                vatRatePercentage
                vatAmountCents
                priceComponentCodename
                registrationEventProductId
                registrationEventProduct {
                  id
                  quantity
                  
                  entry {
                    id
                    competition {
                      id
                      code
                      name
                      ${PersonStatementReportTemplate.fragments.competitionFields}
                    }
                  }

                  eventProduct {
                    id
                    name
                    vatRate {
                      id
                      rate
                    }
                  }
                }
                entryId
                entry {
                  id
                  competition {
                    id
                    code
                    name
                  }
                }
                registrationId
                registration {
                  id
                  athletes {
                    ${PersonStatementReportTemplate.fragments.person}
                  }
                  horses {
                    ${PersonStatementReportTemplate.fragments.horse}
                  }
                }
              }

              revenueItems {
                id
                aggregatedByEntityClass
                amountCents
                vatRatePercentage
                vatAmountCents
                priceComponentCodename
                registrationEventProductId
                registrationEventProduct {
                  id
                  quantity
                  eventProduct {
                    id
                    name
                    vatRate {
                      id
                      rate
                    }
                  }
                }
                entryId
                entry {
                  id
                  rank
                  competition {
                    id
                    code
                    name
                  }
                }
                registrationId
                registration {
                  id
                  athletes {
                    ${PersonStatementReportTemplate.fragments.person}
                  }
                  horses {
                    ${PersonStatementReportTemplate.fragments.horse}
                  }
                }
              }

              totalConfirmedPaymentsAmountCents
              totalExpenseAmountCents
              totalPayableAmountCents
              totalPayoutsAmountCents
              totalPendingReturnsAmountCents
              totalRevenueAmountCents

              pendingManualCreditTransferPayouts {
                id
                recipientContact {
                  id
                  name
                  iban
                }
                amountCents
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.person.id,
          eventId: this.event.id
        };
      },
      update({ person }) {
        return person.eventFinancialReport;
      }
    }
  },
  fragments: {
    eventFields: gql`
      fragment _ on Event {
        ${PersonStatementReportTemplate.fragments.eventFields}
      }
    `
  }
};
</script>
